import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';
import { IconArrowLeft } from '@tabler/icons-react';

type Props = {
  title: string;
  description?: string;
  backTo?: string;
  backLabel?: string;
  actions?: ReactNode;
};

export function AdminPageHeader({ title, description, backTo, backLabel, actions }: Props) {
  return (
    <header className="mb-8">
      {backTo && (
        <Link
          to={backTo}
          className="inline-flex items-center gap-1.5 text-sm text-muted hover:text-navy mb-3 transition-colors"
        >
          <IconArrowLeft size={14} />
          {backLabel ?? 'Back'}
        </Link>
      )}
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="font-serif text-3xl text-ink tracking-tight">{title}</h1>
          {description && <p className="text-sm text-muted mt-1.5 max-w-2xl">{description}</p>}
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
      </div>
    </header>
  );
}
